"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppInitializer = void 0;
const aws_react_1 = require("@mit/aws-react");
const UserController_1 = __importDefault(require("../api/UserController"));
const MedicalApi_1 = __importDefault(require("../api/MedicalApi"));
const Roles_1 = __importDefault(require("../model/Roles"));
require("react-toastify/dist/ReactToastify.css");
const FeatureController_1 = __importDefault(require("../api/FeatureController"));
const DataController_1 = __importDefault(require("../api/DataController"));
const ContactTracingApi_1 = __importDefault(require("../api/ContactTracingApi"));
const Holds_1 = __importDefault(require("../model/Holds"));
const VaccineHolds_1 = __importDefault(require("../model/VaccineHolds"));
const CovidNav_1 = require("../model/CovidNav");
const UserProfileStore_1 = __importDefault(require("../model/UserProfileStore"));
const AppStore_1 = __importDefault(require("../model/AppStore"));
const Defaults_1 = require("../common/Defaults");
const react_1 = require("react");
// interface UseAppInitializationReturnProps {
//   appStore?: AppInterface;
//   pageError?: PageError;
//   userProfileStore?: UserProfileStoreInterface;
//   covidNav?: CovidNavInterface;
//   vaccineHolds?: HoldsModelInterface
//   holds?: HoldsModelInterface;
//   roles?: RolesInterface;
// }
const useAppInitializer = () => {
    (0, react_1.useEffect)(() => {
        (0, aws_react_1.appInitialized)({
            isLoading: true,
            hasAccess: false,
            hasError: false,
        });
    }, []);
    const initializeApp = () => __awaiter(void 0, void 0, void 0, function* () {
        // const [userProfileStoreState, setUserProfileStoreState] = useState<UserProfileStore | undefined>(undefined);
        // const [pageError, setPageError] = useState<PageError>({ error: false, errorText: "" });
        // const [isLoading, setIsLoading] = useState<boolean>(true);
        const featurePromise = UserController_1.default.fetchFeatures();
        const profilePromise = UserController_1.default.fetchProfile();
        const statusesPromise = MedicalApi_1.default.fetchHoldStatuses();
        const vacineHoldStatusesPromise = MedicalApi_1.default.fetchVaccineHoldStatuses();
        const textsPromise = MedicalApi_1.default.fetchTexts();
        const contactTracingStatusPromise = ContactTracingApi_1.default.fetchStatus();
        const rolesPromise = ContactTracingApi_1.default.fetchRoles();
        const exemptionTypesPromise = MedicalApi_1.default.fetchExemptionTypes();
        const featuresPromise = FeatureController_1.default.fetchFeatures();
        const textPromise = DataController_1.default.fetchArray('texts');
        Promise.all([featurePromise, profilePromise, statusesPromise, textsPromise, rolesPromise, vacineHoldStatusesPromise, contactTracingStatusPromise, exemptionTypesPromise, featuresPromise, textPromise])
            .then(([featureResponse, profileResponse, statusesResponse, textsResponse, rolesResponse, vacineStatusesResponse, contactTracingStatusResponse, exemptionTypesResponse, featuresResponse, textResponse]) => {
            var _a, _b;
            console.log('contactTracingStatusResponse.items', contactTracingStatusResponse.items);
            // console.log('vaccineHolds', vaccineHolds.statuses)
            if (contactTracingStatusResponse.items) {
                CovidNav_1.covidNav.contactTracingStatus = contactTracingStatusResponse.items;
                console.log('covidNav.contactTracingStatus', CovidNav_1.covidNav.contactTracingStatus);
            }
            if (textsResponse.items) {
                let texts = textsResponse.items.reduce((all, current) => {
                    return Object.assign(Object.assign({}, all), { [current.id]: current.text });
                }, {});
                CovidNav_1.covidNav.texts = texts;
            }
            console.log('covidNav.texts', CovidNav_1.covidNav.texts);
            let permissions = featureResponse.reduce((obj, curr) => {
                return Object.assign(Object.assign({}, obj), { [curr.id]: curr.value });
            }, {});
            //@ts-ignore
            VaccineHolds_1.default.statuses = vacineStatusesResponse.items;
            console.log('vacineStatusesResponse.items', vacineStatusesResponse.items);
            console.log('vaccineHolds', VaccineHolds_1.default.statuses);
            Holds_1.default.exemptionTypes = exemptionTypesResponse;
            //@ts-ignore
            Holds_1.default.statuses = statusesResponse.items;
            Roles_1.default.roles = rolesResponse.items;
            console.log('rolesResponse', rolesResponse);
            console.log('roles', Roles_1.default);
            Holds_1.default.features = (_a = featuresResponse.data) === null || _a === void 0 ? void 0 : _a.features;
            console.log('track:: featuresResponse', (_b = featuresResponse.data) === null || _b === void 0 ? void 0 : _b.features);
            console.log('track:: holds.features', Holds_1.default.features);
            Holds_1.default.appText = textResponse.items;
            console.log('track:: textResponse', textResponse.items);
            CovidNav_1.covidNav.features = permissions;
            if (rolesResponse.items.length > 0) {
                if (profileResponse.person) {
                    UserProfileStore_1.default.setCurrentUser(profileResponse.person.mitId, profileResponse.person.kerberosId, profileResponse.person.firstName, profileResponse.person.lastName, profileResponse.person.displayName);
                }
            }
            else {
                (0, aws_react_1.appInitialized)({
                    isLoading: false,
                    hasAccess: true,
                    hasError: false
                });
                // setPageError({ error: true, errorText: `You are not authorized for this application. For more information, please contact ${CONTACT_SUPPORT_LINK}.` });
                AppStore_1.default.setPageError(true, `An error occurred and the application could not be loaded. If the problem persists, please contact ${Defaults_1.CONTACT_SUPPORT_LINK}.`);
            }
            // setFeatures(featuresResponse)
            (0, aws_react_1.appInitialized)({
                isLoading: false,
                hasAccess: true,
                hasError: false
            });
            AppStore_1.default.setIsLoading(false);
        })
            .catch((error) => {
            // action(() => {
            (0, aws_react_1.appInitialized)({
                isLoading: false,
                hasAccess: true,
                hasError: false
            });
            AppStore_1.default.setIsLoading(false);
            AppStore_1.default.setPageError(true, `An error occurred and the application could not be loaded. If the problem persists, please contact ${Defaults_1.CONTACT_SUPPORT_LINK}.`);
            // })
            // setPageError({ error: true, errorText: `An error occurred and the application could not be loaded. If the problem persists, please contact ${CONTACT_SUPPORT_LINK}.` });
            // setIsLoading(false);
        });
    });
    return { initializeApp };
};
exports.useAppInitializer = useAppInitializer;
